import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  shareButton: {
    zIndex: 4,
    backgroundColor: ({ palette }) => palette.dark.secondary,
    color: "text.primary",
    borderRadius: "4px",
    "&:hover": {
      color: ({ palette }) => palette.dark.tertiary,
    },
  },

  sharePopup: {
    padding: ({ spacing }) => spacing(2),
    backgroundColor: ({ palette }) => palette.dark.secondary,
    width: "300px",
    marginTop: ({ spacing }) => spacing(2),
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: ({ spacing }) => spacing(2),
  },

  socials: {
    display: "flex",
    gap: ({ spacing }) => spacing(3),
    marginBottom: ({ spacing }) => spacing(2),
  },

  input: {
    width: "100%",

    ".MuiOutlinedInput-notchedOutline": {
      borderColor: "#393939",
    },
  },

  copyIcon: {
    color: "primary.dark",
  },

  socialIcon: {
    color: "#fff",
  },
};
